// ** React Imports
import React, { useEffect, useState } from "react"

// ** Styles Imports
import styles from "./styles.module.css"

// ** Component Imports
import CloseCircle from "../../../../../components/icon-components/CloseCircle/CloseCircle"
import CheckmarkCircle from "../../../../../components/icon-components/CheckmarkCircle/CheckmarkCircle"
import { ReactComponent as CheckedIcon } from "../../../../../components/Radio/icons/radio-selected.svg"
import { ReactComponent as NotCheckedIcon } from "../../../../../components/Radio/icons/radio-not-selected.svg"

function PasswordRequirements({ password = "", containerStyle = {} }) {
  // Track password conditions
  const [conditions, setConditions] = useState({
    length: false,
    containsNumber: false,
    containsCapitalLetter: false,
    containsSmallLetter: false,
    containsSpecialCharacter: false
  })

  // On password change
  useEffect(() => {
    setConditions({
      length: password.length > 7,
      containsNumber: /\d/.test(password),
      containsCapitalLetter: /[A-Z]/.test(password),
      containsSmallLetter: /[a-z]/.test(password),
      containsSpecialCharacter: /[^A-Za-z\d]/.test(password)
    })
  }, [password])

  return (
    <div className={styles.container} style={{ 
      ...containerStyle,
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      fontSize: '13px'
    }}>
      <div
        className={styles.row}
        style={{ color: conditions.length && "#009999" }}
      >
        {conditions.length ? (
          <CheckedIcon width={12} />
        ) : (
          <NotCheckedIcon width={12} />
        )}{" "}
        8+ characters
      </div>
      <div
        className={styles.row}
        style={{
          color: conditions.containsSmallLetter && "#009999"
        }}
      >
        {conditions.containsSmallLetter ? (
          <CheckedIcon width={12} />
        ) : (
          <NotCheckedIcon width={12} />
        )}{" "}
        One small letter
      </div>
      <div
        className={styles.row}
        style={{
          color: conditions.containsCapitalLetter && "#009999"
        }}
      >
        {conditions.containsCapitalLetter ? (
          <CheckedIcon width={12} />
        ) : (
          <NotCheckedIcon width={12} />
        )}{" "}
        One capital letter
      </div>
      <div
        className={styles.row}
        style={{ color: conditions.containsNumber && "#009999" }}
      >
        {conditions.containsNumber ? (
          <CheckedIcon width={12} />
        ) : (
          <NotCheckedIcon width={12} />
        )}{" "}
        Contains a number
      </div>
      <div
        className={styles.row}
        style={{
          color: conditions.containsSpecialCharacter && "#009999"
        }}
      >
        {conditions.containsSpecialCharacter ? (
          <CheckedIcon width={12} />
        ) : (
          <NotCheckedIcon width={12} />
        )}{" "}
        Special character (@, %, _, -)
      </div>
    </div>
  )
}

export default PasswordRequirements
